<app-dialog-container>
  <h1 mat-dialog-title>{{title}}</h1>

  <section class="permissions-box">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <strong>Permissoes do Grupo</strong>
    </div>

    <app-permission-selector
      [catalog]="permissionCatalog"
      [permissions]="permissionsForSelector"
      [selectedIds]="selectedIds"
      [loading]="permissionsLoading"
      [frontFirstGroups]="frontFirstGroups"
      [frontFirstLoading]="frontFirstLoading"
      (selectedIdsChange)="onSelectedIdsChange($event)">
    </app-permission-selector>
  </section>

  <div class="modal-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
    <button type="button" mat-raised-button class="btn-cancel" (click)="dialogRef.close()">
      SAIR
    </button>
    <button type="button" mat-raised-button color="primary" class="btn-create-edit" (click)="confirm()">
      APLICAR
    </button>
  </div>
</app-dialog-container>
